'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = exports.BreadcrumbsItem = exports.BreadcrumbsProvider = exports.Item = exports.Dummy = exports.withBreadcrumbsContainer = exports.withBreadcrumbsItem = exports.withBreadcrumbs = exports.breadcrumbsBearingKey = exports.breadcrumbsThroughArea = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactThrough = require('react-through');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var breadcrumbsThroughArea = exports.breadcrumbsThroughArea = 'breadcrumbs';
var breadcrumbsBearingKey = exports.breadcrumbsBearingKey = 'to';
var withBreadcrumbs = exports.withBreadcrumbs = (0, _reactThrough.throughInterface)(breadcrumbsThroughArea);
var withBreadcrumbsItem = exports.withBreadcrumbsItem = (0, _reactThrough.throughAgent)(breadcrumbsThroughArea, breadcrumbsBearingKey);
var withBreadcrumbsContainer = exports.withBreadcrumbsContainer = (0, _reactThrough.throughContainer)(breadcrumbsThroughArea);

var Dummy = exports.Dummy = function Dummy() {
  return null;
};

var Item = exports.Item = function Item() {
  return null;
};

var BreadcrumbsProvider = exports.BreadcrumbsProvider = _reactThrough.ThroughProvider;
var BreadcrumbsItem = exports.BreadcrumbsItem = (0, _reactThrough.throughAgentFactory)(breadcrumbsThroughArea, breadcrumbsBearingKey);

function prepareProps(props, rename, duplicate, remove) {
  var p = Object.assign({}, props);
  Object.keys(duplicate).forEach(function (k) {
    p[duplicate[k]] = p[k];
  });
  Object.keys(rename).forEach(function (k) {
    p[rename[k]] = p[k];
    delete p[k];
  });
  Object.keys(remove).forEach(function (k) {
    delete p[k];
  });
  return p;
}

var Breadcrumbs_ = function Breadcrumbs_(props) {
  var defaultCompare = function defaultCompare(a, b) {
    return a[breadcrumbsBearingKey].length - b[breadcrumbsBearingKey].length;
  };

  var data = props[breadcrumbsThroughArea];
  var itemsValue = Object.keys(data).map(function (k) {
    return data[k];
  }).sort(props.compare || defaultCompare);
  var Container = props.container || 'span';
  var containerProps = props.containerProps;
  var Item = props.item || 'a';
  var FinalItem = props.finalItem || Item;
  var finalProps = props.finalProps || {};
  var separator = props.separator;
  var count = itemsValue.length;
  var rename = props.renameProps || (Item == 'a' ? {
    to: 'href'
  } : {});
  var duplicate = props.duplicateProps || {};
  var remove = props.removeProps || {};
  return _react2.default.createElement(Container, containerProps, itemsValue.map(function (itemValue, i) {
    return i + 1 < count ? separator ? _react2.default.createElement('span', {
      key: i
    }, _react2.default.createElement(Item, prepareProps(itemValue, rename, duplicate, remove)), separator) : _react2.default.createElement(Item, _extends({
      key: i
    }, prepareProps(itemValue, rename, duplicate, remove))) : _react2.default.createElement(FinalItem, _extends({
      key: i
    }, prepareProps(itemValue, rename, duplicate, remove), finalProps));
  }));
};

var Breadcrumbs = exports.Breadcrumbs = withBreadcrumbsContainer(Breadcrumbs_);